import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatIDR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "Rp 0";
  return "Rp " + Number(n).toLocaleString("id-ID");
};
